import { useContext } from 'react';
import { OccurenceLocationChartsDataContext } from '../contexts/OccurenceLocationChartsDataContext';

export const useOccurenceLocationChartsDataContext = () => {
    return useContext(OccurenceLocationChartsDataContext);
};
